var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jump-form"},[_c('h2',[_vm._v("立即开通案件云，免费试用")]),_c('p',[_vm._v("无需下载部署，注册即用，最快处理案件的桥梁")]),_c('span',{staticClass:"jump-btn",on:{"click":_vm.jumpGuide}},[_vm._v("开始免费使用")])])
}
var staticRenderFns = []

export { render, staticRenderFns }